<template>
  <b-row :class="{
    'pb-4': options.paddingBottom,
    'border-bottom': options.borderBottom,
  }">
    <b-col class="w-100 d-flex justify-content-center">
      <div
        v-for="(step, index) in filteredSteps"
        :key="step.name"
        class="text-center"
      >
        <span
          :class="{
            'step-badge': true,
            'primary-background-color': true,
            'mx-2': true,
            'inactive': index > currentIndex,
          }"
      >
        <span v-if="index >= currentIndex">{{index + 1}}</span>
        <font-awesome-icon v-else icon="check" />
      </span>
      <b class="mr-2">{{step.displayName}}</b>
      <hr v-if="index < filteredSteps.length - 1" class="seperator"/>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'OnboardingSteps',
  props: {
    currentStep: {
      type: Object,
      default: () => null,
    },
    steps: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({
        paddingBottom: true,
        borderBottom: true,
      }),
    }
  },
  computed: {
    filteredSteps() {
      return this.steps.filter(el => el.stepper).map(el => {
        console.log('NAME from stepper: ', el.name);
        if (this.$root.isCXR && el.name === 'skills') {
          el.displayName = 'Your Profile';
        }
        return el;
      });
    },
    currentIndex() {
      return this.filteredSteps.findIndex(el => el.name === this.currentStep.name);
    }
  },
  mounted() {
    console.log(this.filteredSteps);
    console.log(this.currentStep);
    console.log(this.currentIndex);
    console.log('CXR from stepper: ', this.$root.isCXR);
  }
};
</script>

<style lang="scss" scoped>
.onboarding-video {
  width: 100%;
}
.step-badge {
  width: 32px;
  height: 32px;
  display: inline-block;
  line-height: 32px;
  text-align: center;
  border-radius: 16px;
  font-weight: bold;
  color: #fff;

  &.inactive {
    opacity: .5;
  }
}
.seperator {
  display: inline-block;
  width: 24px;
  margin: 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/OnboardingStepper.vue